import React, {Component} from "react"
import {Grid} from "react-bootstrap"
import {connect} from "react-redux"
import {get} from "lodash"

import idHelper from "@irati/utils/id"
import authentication from "@irati/auth"
import TenantHomePageQuery from "@irati/homepage/services/apollo/queries/TenantHomePage"
import {ReduxState} from "@irati/store/types"
import tracking from "@irati-tracking/homepage"

import Layout from "../components/NewHomePage/ManageLayout/Layout"
import HomePageHeader from "../components/NewHomePage/Header"
import {HomePageView} from "../components/NewHomePage/types"

interface Props {
  isMobile: boolean
}

interface State {
  pageView: HomePageView
}

class EditHomePageV2 extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      pageView: props.isMobile ? HomePageView.EMPLOYEE_VIEW : HomePageView.EDIT_CONTENT_VIEW
    }
  }

  onChangePageView = (pageView: HomePageView) => {
    tracking.homePageChangeView(pageView)
    this.setState({pageView})
  }

  render() {
    const {pageView} = this.state
    const {isMobile} = this.props

    const getTenantHomePageVars = {
      isNative: false,
      tenantId: authentication.userTenant().uuid
    }
    const idNamespace = idHelper("HomePage", this.props, {force: true})
    const openModal = get(this.props, "location.state.openModal")

    return (
      <Grid>
        {!isMobile && <HomePageHeader onChangePageView={this.onChangePageView} pageView={pageView} id={idNamespace} />}
        <TenantHomePageQuery variables={getTenantHomePageVars}>
          {({data}) => {
            const {companyNews, layoutWidgets} = data

            if (pageView !== HomePageView.EDIT_LAYOUT_VIEW) {
              return (
                <Layout
                  companyNews={companyNews}
                  id={idNamespace}
                  layoutWidgets={layoutWidgets}
                  pageView={pageView}
                  openModal={openModal} />
              )
            }
          }}
        </TenantHomePageQuery>
      </Grid>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => {
  return {
    isMobile: get(mq, "lessThan.medium", false)
  }
}

export default connect(mapStateToProps)(EditHomePageV2)
